import React, { useEffect } from 'react'
import MemberCard from './MemberCard'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import { shallowEqual, useSelector } from 'react-redux'
import { getUserData } from '../../../entity/user/model/selector/getUserData/getUserData'
import { FiPlusCircle } from 'react-icons/fi'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { getAboutSection, getAboutSectionData } from '../../../entity/about-sections/AboutSection'
import CreateAboutMemberModal from '../../../components/CreateAboutMemberModal/CreateAboutMemberModal'
import { createAboutMember } from '../../../entity/about-member/AboutMember'

const MembersList = () => {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const user = useSelector(getUserData, shallowEqual)
  const aboutSections = useSelector(getAboutSectionData, shallowEqual)

  useEffect(() => {
    dispatch(getAboutSection())
  }, [dispatch])

  const [createModalOpen, setCreateModalOpen] = useState({ open: false, sectionId: null })

  const openModal = sectionId => setCreateModalOpen({ open: true, sectionId })
  const closeModal = () => setCreateModalOpen({ open: false, sectionId: null })

  const createMemberHandler = async (values, { setSubmitting }) => {
    try {
      const formData = new FormData()
      formData.append('name_en', values.name_en)
      formData.append('name_ka', values.name_ka)
      formData.append('position_en', values.position_en)
      formData.append('position_ka', values.position_ka)
      formData.append('location_en', values.location_en)
      formData.append('location_ka', values.location_ka)
      formData.append('sectionId', values.sectionId)
      formData.append('imageUrl', values.imageUrl)

      await dispatch(createAboutMember(formData))
      await dispatch(getAboutSection())
      closeModal()
    } catch (error) {
      console.error('Error updating current issue:', error)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className={styles.members_list_container}>
      {aboutSections?.map(section => {
        const showSectionName = section.name_en !== 'main' && section.name_en !== '_'

        return (
          <div key={section.id} className={styles.section_container}>
            {showSectionName && (
              <h3 className={styles.section_title}>
                {i18n.language === 'ka' ? section.name_ka : section.name_en}
              </h3>
            )}
            <div className={`${showSectionName ? styles.members_container : styles.centered_grid}`}>
              {section.members?.map(member => (
                <MemberCard key={member.id} member={member} />
              ))}
              {user?.role === 'admin' && (
                <div className='border-2 h-[222px] flex items-center justify-center'>
                  <FiPlusCircle
                    className='text-4xl hover:scale-110 transition-all cursor-pointer text-[#326383]'
                    onClick={() => openModal(section.id)}
                  />
                </div>
              )}
            </div>
          </div>
        )
      })}
      {createModalOpen.open && (
        <CreateAboutMemberModal
          isOpen={createModalOpen.open}
          onClose={closeModal}
          onSubmit={createMemberHandler}
          data={{ sectionId: createModalOpen?.sectionId }}
        />
      )}
    </div>
  )
}

export default MembersList
